import React from 'react';
import PropTypes from 'prop-types';
import { strings } from 'APP_ROOT/localization';

export default class PossibleImpactBadge extends React.PureComponent {

    constructor(props) {
        super(props);
    }

    render() {

        let distanceUnitsAreMetric = this.props.unitOfMeasure === 'METRIC';

        let currentSpeed = this.props.currentSpeed;
        if (distanceUnitsAreMetric === false) {
            currentSpeed = Math.round(currentSpeed / 1.60934);
        }

        var summary = "";
        if (distanceUnitsAreMetric) {
            summary = strings.formatString(strings.event_speed_x_kph, currentSpeed);
        } else {
            summary = strings.formatString(strings.event_speed_x_mph, currentSpeed);
        }

        return (
            <div className="possible-impact-badge">
                {summary}
            </div>
        )
    }
}

PossibleImpactBadge.propTypes = {
    currentSpeed: PropTypes.number.isRequired,
    unitOfMeasure: PropTypes.oneOf(['METRIC','IMPERIAL']).isRequired,
};
